/* eslint-disable camelcase */
import SalesAnalysisColumnDefinitionFactory from '@/app/sales_analysis/models/SalesAnalysisColumnDefinitionFactory'

export default class AgGrid {
  constructor ({ col_definition, data, aggregation }) {
    this.columnDefs = col_definition.map((columnDef) => SalesAnalysisColumnDefinitionFactory.create(columnDef))
    this.data = data
    this.aggregation = [{ ...aggregation }]
  }
}



// WEBPACK FOOTER //
// ./src/app/store_growth/models/AgGrid.js